angular.module('shared', [
    'sharedTemplate',
    'shared.justifyReasonModalCtrl',
    'shared.clientsselector-v2', 
    'shared.checking-new-version-dialog',
    'shared.camera',
    'shared.select-period',
    'shared.virtual-list-selector']);